import BlogRightListContainer from "../../../../components/pages/blog/blogPage/BlogRightList";

const BlogRightList = () => {
  return <BlogRightListContainer />;
};

export default BlogRightList;
